import React from "react";
import { Link } from "react-router-dom";
import Navbarnft from "../Components/Navbars/Navbarnft";
import HeaderSlider from "./HeaderSlider";
import Tab from "./Tab";
import featuredDropImage from "../Images/featured-drop-validator.jpg";
import trendingImage from "../Images/trending-cp001.jpg";
import "swiper/css";
import "swiper/css/pagination";
import "./HomeHero.css";

const categories = [
  { name: "Art", icon: "🎨" },
  { name: "Gaming", icon: "🎮" },
  { name: "Membership", icon: "💎" },
  { name: "Metaverse", icon: "🪐" },
  { name: "Utility", icon: "⚡" },
];

const steps = [
  { title: "Connect wallet", text: "Link your wallet to sign in securely. No gas fees to log in." },
  { title: "Create collection", text: "Set up your collection, royalties and branding in minutes." },
  { title: "Mint NFTs", text: "Upload art, music or media and mint straight to the chain." },
  { title: "List & earn", text: "Sell on the marketplace and earn royalties on every resale." },
];

export default function Home({ UserWallet, signMessage, logout, URL }) {
  return (
    <>
      <Navbarnft
        UserWallet={UserWallet}
        signMessage={signMessage}
        logout={logout}
        URL={URL}
      />

      <section className="w3-hero">
        <div className="w3-container w3-hero-inner">
          <div>
            <span className="w3-pill w3-glass">
              <i /> Live on MAAL Chain
            </span>
            <h1>
              Discover, collect &amp; trade{" "}
              <span className="w3-gradient-text">extraordinary NFTs</span>
            </h1>
            <p className="lead">
              PanSea is the marketplace for crypto collectibles. Buy, sell and
              mint digital art, gaming assets, memberships and more.
            </p>
            <div className="w3-hero-cta">
              <Link to="/categories/Art" className="w3-btn w3-btn-primary">
                Explore marketplace
              </Link>
              <Link to="/createnft" className="w3-btn">
                Start creating
              </Link>
            </div>
            <div className="w3-hero-stats">
              <div><b>5</b><span>Categories</span></div>
              <div><b>0%</b><span>Login gas fees</span></div>
              <div><b>Royalties</b><span>On every resale</span></div>
            </div>
          </div>
          <div className="w3-hero-art" aria-hidden="true">
            <div className="w3-art-card w3-glass a">
              <img src={featuredDropImage} alt="" />
              <div>Featured drop <small>MAAL Validator</small></div>
            </div>
            <div className="w3-art-card w3-glass b">
              <img src={trendingImage} alt="" />
              <div>Trending <small>CP001</small></div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3-section">
        <div className="w3-container">
          <div className="w3-section-head">
            <div>
              <div className="w3-eyebrow">Spotlight</div>
              <h2 className="w3-title">Featured collections</h2>
            </div>
          </div>
          <HeaderSlider UserWallet={UserWallet} URL={URL} />
        </div>
      </section>

      <section className="w3-section">
        <div className="w3-container">
          <div className="w3-section-head">
            <div>
              <div className="w3-eyebrow">Trending</div>
              <h2 className="w3-title">Notable collections</h2>
            </div>
          </div>
          <Tab UserWallet={UserWallet} URL={URL} />
        </div>
      </section>

      <section className="w3-section">
        <div className="w3-container">
          <div className="w3-section-head">
            <div>
              <div className="w3-eyebrow">Browse</div>
              <h2 className="w3-title">Shop by category</h2>
            </div>
          </div>
          <div className="w3-cats">
            {categories.map((c) => (
              <Link key={c.name} to={`/categories/${c.name}`} className="w3-cat w3-glass">
                <em>{c.icon}</em>
                {c.name}
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="w3-section">
        <div className="w3-container">
          <div className="w3-section-head">
            <div>
              <div className="w3-eyebrow">Get started</div>
              <h2 className="w3-title">Create and sell your NFTs</h2>
            </div>
          </div>
          <div className="w3-steps">
            {steps.map((s, i) => (
              <div key={s.title} className="w3-step w3-glass">
                <b>{i + 1}</b>
                <h4>{s.title}</h4>
                <p>{s.text}</p>
              </div>
            ))}
          </div>
          <div className="w3-cta w3-glass">
            <h2>Ready to <span className="w3-gradient-text">mint your first NFT?</span></h2>
            <p>Join creators and collectors building on PanSea.</p>
            <Link to="/createnft" className="w3-btn w3-btn-primary">Create now</Link>
          </div>
        </div>
      </section>
    </>
  );
}
